import Moment from "moment";

export default class Time {
  static formatShort(date: Date | string) {
    Moment.locale("sv");
    const now = Moment(new Date());
    const today = Moment().startOf("day");
    const then = Moment(date);
    const isSameDay = today.valueOf() - then.valueOf() <= 0;
    const isSameWeek = now.week() - then.week() === 0;
    const isSameYear = now.year() - then.year() === 0;

    if (isSameDay) {
      return `Idag, ${Moment(date).format("HH:mm")}`;
    } else if (isSameWeek && isSameYear) {
      return Moment(date).format("ddd, HH:mm");
    } else if (isSameYear) {
      return Moment(date).format("D MMM");
    } else {
      return Moment(date).format("D MMM YYYY");
    }
  }

  static formatLong(date: Date | string | undefined) {
    Moment.locale("sv");
    return Moment(date).format("dddd DD MMM YYYY, HH:mm");
  }

  static formatISOShort(date: Date | string) {
    return Moment(date).format("YYYY-MM-DD");
  }

  static isDateInTwoYearsPeriod(date: Date | string) {
    const lastDayOfCurrentMonth = Moment().endOf("month");
    const firstDay24MonthsAgo = Moment().subtract(2, "years").startOf("month");
    const targetDate = Moment(date);

    return targetDate.isBetween(
      firstDay24MonthsAgo,
      lastDayOfCurrentMonth,
      undefined,
      "[]"
    );
  }
}
